import React from 'react';
import { useSelector } from 'react-redux';

import Singles from './Singles';
import Parlay from './Parlay';
import MultiplesBuilder from '../MultiplesBuilder';

import {
    selectDisplaySinglesContent,
    selectDisplayParlayContent,
    selectDisplayMultiplesContent,
} from '~Betslip/selectors/uiSelectors';

import './styles.scss';

const AvailableBetTypes = () => {
    const isSinglesTab = useSelector(selectDisplaySinglesContent);
    const isParlayTab = useSelector(selectDisplayParlayContent);
    const isMultiplesTab = useSelector(selectDisplayMultiplesContent);

    const renderAvailableBetTypes = () => {
        if (isSinglesTab) {
            return <Singles />;
        }

        if (isParlayTab) {
            return <Parlay />;
        }

        if (isMultiplesTab) {
            return <MultiplesBuilder />;
        }

        return null;
    };

    return (
        <>
            {renderAvailableBetTypes()}
        </>
    );
};

export default AvailableBetTypes;
